import React from 'react';
import SectionTitle from '../../components/SectionTitles/SectionTitle';
import JobForm from '../../components/ContactFrom/JobForm';

const JobApply = () => {
    return (
        <div className="contact-form-section section section-padding-t90-b100 bg-primary-blue">
            <div className="container">
                <div className="row">
                    <div className="offset-lg-2 col-lg-8">
                        <SectionTitle
                            headingOption="fz-32"
                            title="Enter your details and upload resume"
                            subTitle="We promise to reach out to you..."
                        />
                        <JobForm />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JobApply
